<mat-form-field appearance="fill">
  <mat-label>Brand</mat-label>
  <mat-select (selectionChange)="changeBrand($event)" [(value)]="selected._id">
    <mat-option *ngFor="let brand of brands" [value]="brand._id">
      {{brand.name}}
    </mat-option>
  </mat-select>
</mat-form-field>
